/**
 * @property {any[]} excludedValues
 */
export default class ExclusionSet {
    constructor() {
        this.excludedValues = [];
    }

    /**
     * Empties this exclusion set.
     * @return {ExclusionSet}
     */
    empty() {
        this.excludedValues.splice(0);
        return this;
    }

    /**
     * Adds given `value` to this exclusion set.
     *
     * If given `value` is already present in this exclusion set (is "excluded"), this method has no effect.
     * @param {any} value
     * @return {ExclusionSet}
     */
    exclude(value) {
        if (!this.excludedValues.includes(value)) {
            this.excludedValues.push(value);
        }

        return this;
    }

    /**
     * Removes given `value` from this exclusion set.
     *
     * If given `value` is not present in this exclusion set (is "included"), this method has no effect.
     * @param {any} value
     * @return {ExclusionSet}
     */
    include(value) {
        const index = this.excludedValues.indexOf(value);
        if (index !== -1) {
            this.excludedValues.splice(index, 1);
        }

        return this;
    }

    /**
     * Returns a boolean indicating whether exclusion set is empty (no value excluded).
     * @return {boolean}
     */
    get isEmpty() {
        return this.excludedValues.length === 0;
    }

    /**
     * Returns a boolean indicating whether given `value` is present in exclusion set.
     * @param {any} value
     * @return {boolean}
     */
    isExcluded(value) {
        return this.excludedValues.includes(value);
    }

    /**
     * Adds given `value` to this exclusion set if it wasn't already present, or removes given `value` from exclusion
     * set if it was present.
     * @param {any} value
     * @return {ExclusionSet}
     */
    toggle(value) {
        this[this.excludedValues.includes(value) ? "include" : "exclude"](value);
        return this;
    }
}
